// src/pages/CampaignDashboard/modals/AddProspectModal.js

import React, { useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';

const IconWithPopup = ({ message }) => {
    // ... (IconWithPopup component from original file, if you want to keep it local)
};


const AddProspectModal = ({ isOpen, onClose, onAddContact }) => {
    const [newContact, setNewContact] = useState({
        company_name: '',
        industry: '',
        company_email: '',
        company_linkedin: '',
        rep_name: '',
        rep_email: '',
        rep_linked: '',
    });

    if (!isOpen) return null;

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setNewContact((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddContact(newContact); // Pass the form data to the parent handler
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="w-[700px] bg-white p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold mb-4">Add New Prospect</h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Left Column */}
                        <div>
                            {/* Company Name Input */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">
                                    Company Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="company_name"
                                    value={newContact.company_name}
                                    onChange={handleFormChange}
                                    className="w-full px-3 py-2 border rounded"
                                    required
                                />
                            </div>
                            {/* ... other input fields for industry, company_email, etc. */}
                        </div>
                        {/* Right Column */}
                        <div>
                            {/* ... input fields for rep_name, rep_email, etc. */}
                        </div>
                    </div>
                    <div className="flex justify-end space-x-4 mt-4">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded-full">
                            Cancel
                        </button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-full">
                            Add
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddProspectModal;